import React from "react";
import cvm from "react-component-visibility";
import assign from "object-assign";

let PositionAwareElement = React.createClass({
    propTypes: {
        onChange: React.PropTypes.func
    },
    mixins: [cvm],
    getInitialState() {
        return {};
    },
    componentVisibilityChanged(visibilityChanged, vPositionChanged, hPositionChanged) {
        if (this.props.onChange) {
            this.props.onChange(visibilityChanged, vPositionChanged, hPositionChanged, assign({}, this.state));
        }
    },
    render() {
        return (
            <div
                className={[this.props.className, (this.state.visible ? "on-screen" : "off-screen"), (this.state.leftHalf ? "left-half" : "right-half"), (this.state.topHalf ? "top-half" : "bottom-half"), (this.state.topThird ? "top-third" : null), (this.state.middleVThird ? "middle-v-third" : null), (this.state.bottomThird ? "bottom-third" : null)].join(" ")}>
                {this.props.children}
            </div>
        );
    }
});

export default PositionAwareElement;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/components/PositionAwareElement.js
 **/